// import ja from "assets/locales/ja"

// export const getLocale = () => "ja"
// export const setLocale = () => {}
// export const toggleLocale = () => {}
// export const getMessages = () => ja

// 以下、英語版対応不要のためコメントアウト

import ja from "assets/locales/ja"
import history from "govHistory"

export const getLocale = () => "ja"

export const getMessages = () => ja

export const getLocaleJaOrEnInitialUpper = () => "Ja"

export const getTopPagePath = () => "/"

export const moveToTop = () => {
  history.push(getTopPagePath())
}
